import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export function useUserPermission(owner) {
    const { ownerUser } = useSelector(state => ({
        ownerUser: state.global.ownerUser
    }));

    const [permission, setPermission] = useState({
        editable: false,
        viewable: false,
        emergency: false
    });

    useEffect(() => {
        const user = owner || ownerUser;
        setPermission({
            editable: !user || !user.permission || user.permission.edit,
            viewable: !user || !user.permission || user.permission.View,
            emergency: user?.permission?.emergency
        });
    }, [ownerUser, owner]);

    return permission;
}